import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";

const Main = lazy(
  () => import("../components/forgotPassword/forgotPasswordSuccess")
);

const ForgotPasswordSuccess = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ForgotPasswordSuccess;
